import { ProgrammingReportAttributes } from 'spw-redux/modules/reports/types';
import { REPORT_TYPES } from 'spw-programming-projects/constants';
import { Report } from '../Report';
import ProgramSummaryReport from './ProgramSummaryReport';

export default class ProgrammingReportFactory {
  static create(attributes: ProgrammingReportAttributes): Report {
    switch (attributes.reportType) {
      case REPORT_TYPES.PROGRAM_SUMMARY: {
        return new ProgramSummaryReport(attributes);
      }
      default:
        throw new Error("The report type doesn't exist");
    }
  }
}
